// src/components/audition-booking-wizard/Step4_UploadVideo.jsx
import React from 'react';
import { Button, Form, Spinner, Alert, ProgressBar } from 'react-bootstrap';
import { FaCloudUploadAlt } from 'react-icons/fa';
import { MAX_SIZE_MB, MAX_DURATION_SEC } from './utils/videoCompression'; // Import constants

const Step4_UploadVideo = ({
    bookingMode, handleNext,
    loading, status, compressProgress, uploadProgress, originalSize, compressedSize,
    handleInitialUploadFileChange, auditionDetails
}) => {
    /* if (bookingMode !== 'ONLINE') { // Check for 'ONLINE' directly as bookingMode is derived from selectedMode
        return null; // This step is only for online mode
    } */
console.log("bookingMode---",bookingMode);
    return (
        <div className="step_3_inside_custom text-center py-4 animate-fade-in">
            <h5 className="text-white mb-4">Upload Your Audition Video</h5>
            <div className="upload-box-premium p-5 border border-dashed border-danger rounded-4 mx-auto" style={{ maxWidth: '600px', background: 'rgba(239, 68, 68, 0.03)' }}>
                <FaCloudUploadAlt size={60} className="text-danger mb-3" />
                <h5 className="text-white">Select Audition File</h5>
                <p className="small text-light">Note: Max size: {MAX_SIZE_MB}MB (MP4/MOV), Max duration: {MAX_DURATION_SEC / 60} minutes</p>
                <Form.Group className="mb-3">
                    <Form.Control
                        type="file"
                        accept="video/mp4,video/quicktime"
                        onChange={handleInitialUploadFileChange}
                        disabled={loading}
                    />
                </Form.Group>
                {originalSize && (
                    <Alert variant="info">
                        📦 Original Size: <b>{originalSize}</b><br />
                        🗜 Compressed Size:{" "}
                        <b>{compressedSize || "processing..."}</b>
                    </Alert>
                )}
                {loading && (
                    <>
                        <div className="mb-1">Compression Progress</div>
                        <ProgressBar
                            animated
                            now={compressProgress}
                            label={`${compressProgress}%`}
                            className="mb-3"
                        />

                        <div className="mb-1">Upload Progress</div>
                        <ProgressBar
                            striped
                            variant="success"
                            now={uploadProgress}
                            label={`${uploadProgress}%`}
                        />

                        <Spinner className="mt-3 text-white" animation="border" size="sm"/>
                    </>
                )}
                {status && <Alert className="mt-3">{status}</Alert>}
            </div>
            {(auditionDetails?.videoUrl || status.includes("successful")) && (
                 <div className="mt-5"><Button className="btn-next-white px-5" onClick={handleNext}>PROCEED TO DETAILS</Button></div>
            )}
        </div>
    );
};

export default Step4_UploadVideo;